<form [formGroup]="findingDescriptionTabForm" (submit)="$event.preventDefault()">
  <mat-card style="box-shadow: none;">
    <mat-card-content class="container-fluid">
      <div class="row mat-card-content">
        <!-- For Deficencies -->
        <section class="row" id="IDR_RDR_Block" *ngIf="isIdrRdrBlockVisible()">
          <div class="col-sm-4">
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["descriptionOfConditionEn"]}} <span
                  *ngIf="isRequired('descriptionOfConditionEn')" class="required"></span></label>
              <div class="control-col">
                <angular-editor [id]="'descriptionOfConditionEn'" formControlName="descriptionOfConditionEn"
                  [config]="configDescEn"></angular-editor>
                <mat-error *ngIf="getErrorMessage('descriptionOfConditionEn') as errorMessage">{{ errorMessage }}</mat-error>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["descriptionOfConditionRu"]}}</label>
              <div class="control-col">
                <angular-editor [id]="'descriptionOfConditionRu'" formControlName="descriptionOfConditionRu"
                  [config]="configDescRu"></angular-editor>
                <mat-error *ngIf="getErrorMessage('descriptionOfConditionRu') as errorMessage">{{ errorMessage }}</mat-error>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["descriptionOfConditionKz"]}}</label>
              <div class="control-col">
                <angular-editor [id]="'descriptionOfConditionKz'" formControlName="descriptionOfConditionKz"
                  [config]="configDescKz"></angular-editor>
                <mat-error *ngIf="getErrorMessage('descriptionOfConditionKz') as errorMessage">{{ errorMessage }}</mat-error>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["riskScenarioDescriptionEn"]}} <span
                  *ngIf="isRequired('riskScenarioDescriptionEn')" class="required"></span></label>
              <div class="control-col">
                <angular-editor [id]="'riskScenarioDescriptionEn'" formControlName="riskScenarioDescriptionEn"
                  [config]="configRiskEn"></angular-editor>
                <mat-error *ngIf="getErrorMessage('riskScenarioDescriptionEn') as errorMessage">{{ errorMessage }}</mat-error>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["riskScenarioDescriptionRu"]}}</label>
              <div class="control-col">
                <angular-editor [id]="'riskScenarioDescriptionRu'" formControlName="riskScenarioDescriptionRu"
                  [config]="configRiskRu"></angular-editor>
                <mat-error *ngIf="getErrorMessage('riskScenarioDescriptionRu') as errorMessage">{{ errorMessage }}</mat-error>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["riskScenarioDescriptionKz"]}}</label>
              <div class="control-col">
                <angular-editor [id]="'riskScenarioDescriptionKz'" formControlName="riskScenarioDescriptionKz"
                  [config]="configRiskKz"></angular-editor>
                <mat-error *ngIf="getErrorMessage('riskScenarioDescriptionKz') as errorMessage">{{ errorMessage }}</mat-error>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["implementedSafeguardsDescriptionEn"]}} <span
                  *ngIf="isRequired('implementedSafeguardsDescriptionEn')" class="required"></span></label>
              <div class="control-col">
                <angular-editor [id]="'implementedSafeguardsDescriptionEn'"
                  formControlName="implementedSafeguardsDescriptionEn" [config]="configSafeguardsEn"></angular-editor>
                <mat-error *ngIf="getErrorMessage('implementedSafeguardsDescriptionEn') as errorMessage">{{ errorMessage }}</mat-error>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["implementedSafeguardsDescriptionRu"]}}</label>
              <div class="control-col">
                <angular-editor [id]="'implementedSafeguardsDescriptionRu'"
                  formControlName="implementedSafeguardsDescriptionRu" [config]="configSafeguardsRu"></angular-editor>
                <mat-error *ngIf="getErrorMessage('implementedSafeguardsDescriptionRu') as errorMessage">{{ errorMessage }}</mat-error>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["implementedSafeguardsDescriptionKz"]}}</label>
              <div class="control-col">
                <angular-editor [id]="'implementedSafeguardsDescriptionKz'"
                  formControlName="implementedSafeguardsDescriptionKz" [config]="configSafeguardsKz"></angular-editor>
                <mat-error *ngIf="getErrorMessage('implementedSafeguardsDescriptionKz') as errorMessage">{{ errorMessage }}</mat-error>
              </div>
            </div>
          </div>
        </section>
        <section class="row" id="ITR_Block" *ngIf="isItrBlockVisible()">
          <div class="col-sm-4">
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["concernsEn"]}} <span *ngIf="isRequired('concernsEn')"
                  class="required"></span></label>
              <div class="control-col">
                <angular-editor [id]="'concernsEn'" formControlName="concernsEn"
                  [config]="configConcernsEn"></angular-editor>
                <mat-error *ngIf="getErrorMessage('concernsEn') as errorMessage">{{ errorMessage }}</mat-error>
            </div>
          </div>
      </div>
      <div class="col-sm-4">
        <div class="horizontal-form-field">
          <label class="form-label">{{displayNames["concernsRu"]}}</label>
          <div class="control-col">
            <angular-editor [id]="'concernsRu'" formControlName="concernsRu" [config]="configConcernsRu"></angular-editor>
            <mat-error *ngIf="getErrorMessage('concernsRu') as errorMessage">{{ errorMessage }}</mat-error>
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="horizontal-form-field">
          <label class="form-label">{{displayNames["concernsKz"]}}</label>
          <div class="control-col">
            <angular-editor [id]="'concernsKz'" formControlName="concernsKz" [config]="configConcernsKz"></angular-editor>
            <mat-error *ngIf="getErrorMessage('concernsKz') as errorMessage">{{ errorMessage }}</mat-error>
          </div>

        </div>
      </div>
      <div class="col-sm-4">
        <div class="horizontal-form-field">
          <label class="form-label">{{displayNames["recomendedResolutionEn"]}} <span
              *ngIf="isRequired('recomendedResolutionEn')" class="required"></span></label>
          <div class="control-col">
            <angular-editor [id]="'recomendedResolutionEn'" formControlName="recomendedResolutionEn"
              [config]="configResolutionEn"></angular-editor>
            <mat-error *ngIf="getErrorMessage('recomendedResolutionEn') as errorMessage">{{ errorMessage }}</mat-error>
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="horizontal-form-field">
          <label class="form-label">{{displayNames["recomendedResolutionRu"]}}</label>
          <div class="control-col">
            <angular-editor [id]="'recomendedResolutionRu'" formControlName="recomendedResolutionRu"
              [config]="configResolutionRu"></angular-editor>
            <mat-error *ngIf="getErrorMessage('recomendedResolutionRu') as errorMessage">{{ errorMessage }}</mat-error>
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="horizontal-form-field">
          <label class="form-label">{{displayNames["recomendedResolutionKz"]}}</label>
          <div class="control-col">
            <angular-editor [id]="'recomendedResolutionKz'" formControlName="recomendedResolutionKz"
              [config]="configResolutionKz"></angular-editor>
            <mat-error *ngIf="getErrorMessage('recomendedResolutionKz') as errorMessage">{{ errorMessage }}</mat-error>
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="horizontal-form-field">
          <label class="form-label">{{displayNames["needMitigation"]}}</label>
          <mat-slide-toggle formControlName="needMitigation" color="primary">
            {{ form.get('needMitigation')?.value ? 'Yes' : 'No' }}
          </mat-slide-toggle>
          <mat-error *ngIf="getErrorMessage('needMitigation') as errorMessage">{{ errorMessage }}</mat-error>
        </div>
      </div>
      <section class="row" *ngIf="showRecommendedMitigation">
        <div class="col-sm-4">
          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames["recomendedMitigationEn"]}} <span
                *ngIf="isRequired('recomendedMitigationEn')" class="required"></span></label>
            <div class="control-col">
              <angular-editor [id]="'recomendedMitigationEn'" formControlName="recomendedMitigationEn"
                [config]="configMitigationEn"></angular-editor>
              <mat-error *ngIf="getErrorMessage('recomendedMitigationEn') as errorMessage">{{ errorMessage }}</mat-error>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames["recomendedMitigationRu"]}}</label>
            <div class="control-col">
              <angular-editor [id]="'recomendedMitigationRu'" formControlName="recomendedMitigationRu"
                [config]="configMitigationRu"></angular-editor>
              <mat-error *ngIf="getErrorMessage('recomendedMitigationRu') as errorMessage">{{ errorMessage }}</mat-error>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames["recomendedMitigationKz"]}}</label>
            <div class="control-col">
              <angular-editor [id]="'recomendedMitigationKz'" formControlName="recomendedMitigationKz"
                [config]="configMitigationKz"></angular-editor>
              <mat-error *ngIf="getErrorMessage('recomendedMitigationKz') as errorMessage">{{ errorMessage }}</mat-error>
            </div>
          </div>
        </div>
      </section>


      </section>
      </div>
    </mat-card-content>
  </mat-card>
</form>
